<script>
import TemplateHeaderTableNew from '@/components/TemplateHeaderTableList'
import { downloadAction, getAction, getParams } from '@/command/netTool'
import Big from 'big.js'
import { Tooltip } from 'ant-design-vue'
import { productOrderTypeList } from '@/utils/textFile'

export default {
  name: 'dataReportRefundGf',
  data() {
    return {
      loading: false,
      records: [],
      totalData: null,
      current: 1,
      total: 1,
      // listUrl: '/reportForm/getMerchantReportPage',
      params: { current: 1, pageSize: 10 },
      paramsValue: {},
      businessIdList: [],
      headerTypeData: {
        fromType: [
          {
            name: '农家特产',
            value: '1',
          },
          {
            name: '农家乐',
            value: '2',
          },
          {
            name: '农事体验',
            value: '4',
          },
          {
            name: '酒店民宿',
            value: '13',
          },
          {
            name: '景点门票',
            value: '12',
          },
          {
            name: '组合套餐',
            value: '14',
          },
        ],
        status: [
          {
            name: '待使用',
            value: '1',
          },
          {
            name: '待发货',
            value: '2',
          },
          {
            name: '待签收',
            value: '3',
          },
          {
            name: '待评价',
            value: '4',
          },
          {
            name: '已完成',
            value: '5',
          },
          {
            name: '已关闭',
            value: '6',
          },
        ],
        businessId: [],
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getTotal(params) {
      return new Promise((resolve) => {
        // if (this.totalData) {
        //   resolve(this.totalData)
        // } else {
        this.params = {
          ...this.params,
          ...params,
        }
        getAction('/reportForm/getRefundReportCount', params).then((e) => {
          this.totalData = e.data
          resolve(e.data)
        })
        // }
      })
    },
    getSum(list) {
      let refundAmount = 0
      let refundCount = 0
      let feeAmount = 0
      let returnFreightAmount = 0

      list.forEach((e) => {
        refundAmount = parseFloat(new Big(e.refundAmount || 0).plus(refundAmount))
        feeAmount = parseFloat(new Big(e.feeAmount || 0).plus(feeAmount))
        returnFreightAmount = parseFloat(new Big(e.returnFreightAmount || 0).plus(returnFreightAmount))
        refundCount = parseFloat(new Big(e.refundCount || 0).plus(refundCount))
      })
      return {
        orderSn: '合计',
        refundAmount,
        refundCount,
        feeAmount,
        returnFreightAmount,
      }
    },
    getList(params = this.params) {
      this.loading = true
      this.getTotal(params).then((total) => {
        getAction('/reportForm/getRefundReportPage', params).then((e) => {
          this.loading = false
          this.records = e.data['records'].map((e) => ({ ...e, dateTypeQuery: params.dateTypeQuery }))
          this.params = params
          this.params['current'] = e.data['current']
          this.params['pageSize'] = e.data['pageSize']
          this.current = e.data['current']
          this.total = e.data['total']
          if (this.records.length !== 0) {
            this.records.push(this.getSum(e.data['records']))
            this.records.push({
              ...total,
              orderSn: '总计',
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    getHeader() {
      return [
        {
          name: '订单编号',
          type: 'input',
          key: 'orderSn',
        },
        {
          name: '下单时间',
          type: 'rangePicker',
          keys: ['dateGe', 'dateLe'],
        },
        {
          name: '退款时间',
          type: 'rangePicker',
          keys: ['refundDateGe', 'refundDateLe'],
        },
        {
          name: '商品名称',
          type: 'input',
          key: 'productName',
        },
        {
          name: '商户名称',
          type: 'input',
          key: 'businessName',
        },
        {
          name: '收货人姓名',
          type: 'input',
          key: 'buyName',
        },
        {
          name: '手机号',
          type: 'input',
          key: 'buyPhone',
        },
        {
          name: '订单类型',
          type: 'select',
          key: 'orderType',
          typeData: productOrderTypeList,
        },
        {
          type: 'select',
          name: '商品类型',
          key: 'fromType',
        },
      ]
    },
    getColumns() {
      return [
        {
          title: '订单编号',
          dataIndex: 'orderSn',
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          customRender: (text, records) => {
            return (
              <div class="product-order-item">
                <Tooltip title={text}>{text}</Tooltip>
              </div>
            )
          },
        },
        {
          title: '规格编码',
          dataIndex: 'skuCode',
          width: '100px',
          customRender: (text, records) => {
            return text || '-'
          },
        },
        {
          title: '商户名称',
          dataIndex: 'businessName',
        },
        {
          title: '收货人姓名',
          width: '100px',
          dataIndex: 'receiverName',
        },
        {
          title: '收货人电话',
          width: '100px',
          dataIndex: 'receiverPhone',
        },
        {
          dataIndex: 'orderType',
          title: '订单类型',
          align: 'left',
        },
        {
          title: '收货人地址',
          width: '100px',
          dataIndex: 'receiverAddress',
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
        },
        {
          title: '退款时间',
          dataIndex: 'refundTime',
        },
        {
          title: '退款数量',
          width: '100px',
          dataIndex: 'refundCount',
        },
        {
          title: '退款金额',
          width: '60px',
          dataIndex: 'refundAmount',
        },
        {
          title: '退款运费',
          width: '60px',
          dataIndex: 'returnFreightAmount',
          customRender: (text, records) => {
            return text || '0'
          },
        },
        {
          title: '状态',
          dataIndex: 'status',
          customRender: (text, records) => {
            if (records.pickUpId && text == 2) {
              return '待取货'
            }
            return this.headerTypeData.status.find((d) => d.value == text).name
          },
        },
      ]
    },
    onChange(data, filter) {
      this.getList(data)
    },
    getRightButton() {
      return [
        {
          name: '导出Excel',
          type: 'normal2',
          onClick: (data) => {
            const { dateGe, dateLe, fromType, productName } = this.params
            const exportParams = { ...this.params }
            delete exportParams.current
            delete exportParams.pageSize
            delete exportParams.size
            let urlParam = ''

            const keys = Object.keys(exportParams)
            keys.forEach((ele) => {
              if (exportParams[ele]) {
                urlParam = urlParam + `${ele}=${exportParams[ele]}&`
              }
            })

            if (this.businessIdList.length > 0) {
              urlParam = urlParam
                ? urlParam + `&ids=${this.businessIdList.slice(0, 100).join(',')}`
                : `ids=${this.businessIdList.slice(0, 100).join(',')}`
            }
            if (this.businessIdList.length > 100) {
              this.$message.warning('导出100条以内数据')
            }

            downloadAction(`/api/reportForm/exportRefundReportFormV2?${urlParam}`, '退款明细.xlsx')
          },
        },
      ]
    },
    selectRow(data, records) {
      this.businessIdList = records.map((d) => d.id)
    },
  },
  render() {
    return (
      <TemplateHeaderTableNew
        ref={'table'}
        records={this.records}
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        rightButton={this.getRightButton()}
        button={[]}
        filterRightButtonKey={['refresh', 'setting']}
        onChange={this.onChange}
        headerTypeData={this.headerTypeData}
        onSelectRow={this.selectRow}
      />
    )
  },
}
</script>

<style lang="less" scoped>
.product-order-item {
  text-overflow: ellipsis;
  width: 200px;
  display: block;
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 200px;
    display: block;
  }
}
</style>

